import React from 'react';
import './Social.scss';
import GoogleLogo from '../../img/logos/google.svg';
import AmazonLogo from '../../img/logos/amazon.svg';
import AppleLogo from '../../img/logos/apple.svg';
import CocaLogo from '../../img/logos/cocacola.svg';
import MicrosoftLogo from '../../img/logos/microsoft.svg';
import NetflixLogo from '../../img/logos/netflix.svg';
import NikeLogo from '../../img/logos/nike.svg';
import SpotifyLogo from '../../img/logos/spotify.svg';
import FacebookLogo from '../../img/logos/facebook.svg';
import DisneyLogo from '../../img/logos/disney.svg';
import HpLogo from '../../img/logos/hp.svg';
import McdonaldLogo from '../../img/logos/mcdonald.svg';
function Social() {
  return (
    <div className="companies">
      <h2 className="companies__title">Инвестируй в акции и зарабатывай</h2>
      <p className="companies__subtitle">
        Бесплатное обучение, интересные ачивки и доступ к акциям лидирущих
        компаний
      </p>
      <div class="animation-infinite">
        <div>
          <div className="logos">
            <div className="logo__box">
              <img className="logo-img" src={GoogleLogo} alt="google"></img>
            </div>
            <div className="logo__box">
              <img className="logo-img" src={AmazonLogo} alt="amazon"></img>
            </div>
            <div className="logo__box">
              <img className="logo-img" src={AppleLogo} alt="apple"></img>
            </div>
            <div className="logo__box">
              <img className="logo-img" src={CocaLogo} alt="coca"></img>
            </div>
            <div className="logo__box">
              <img
                className="logo-img"
                src={MicrosoftLogo}
                alt="microsoft"
              ></img>
            </div>
            <div className="logo__box">
              <img className="logo-img" src={NetflixLogo} alt="netflix"></img>
            </div>
            <div className="logo__box">
              <img className="logo-img" src={NikeLogo} alt="nike"></img>
            </div>
            <div className="logo__box">
              <img className="logo-img" src={SpotifyLogo} alt="spotify"></img>
            </div>
            <div className="logo__box">
              <img className="logo-img" src={FacebookLogo} alt="facebook"></img>
            </div>
            <div className="logo__box">
              <img className="logo-img" src={DisneyLogo} alt="disney"></img>
            </div>
            <div className="logo__box">
              <img className="logo-img" src={HpLogo} alt="hp"></img>
            </div>
            <div className="logo__box">
              <img className="logo-img" src={McdonaldLogo} alt="mcdonald"></img>
            </div>
          </div>
          <div className="logos">
            <div className="logo__box">
              <img className="logo-img" src={GoogleLogo} alt="google"></img>
            </div>
            <div className="logo__box">
              <img className="logo-img" src={AmazonLogo} alt="amazon"></img>
            </div>
            <div className="logo__box">
              <img className="logo-img" src={AppleLogo} alt="apple"></img>
            </div>
            <div className="logo__box">
              <img className="logo-img" src={CocaLogo} alt="coca"></img>
            </div>
            <div className="logo__box">
              <img
                className="logo-img"
                src={MicrosoftLogo}
                alt="microsoft"
              ></img>
            </div>
            <div className="logo__box">
              <img className="logo-img" src={NetflixLogo} alt="netflix"></img>
            </div>
            <div className="logo__box">
              <img className="logo-img" src={NikeLogo} alt="nike"></img>
            </div>
            <div className="logo__box">
              <img className="logo-img" src={SpotifyLogo} alt="spotify"></img>
            </div>
            <div className="logo__box">
              <img className="logo-img" src={FacebookLogo} alt="facebook"></img>
            </div>
            <div className="logo__box">
              <img className="logo-img" src={DisneyLogo} alt="disney"></img>
            </div>
            <div className="logo__box">
              <img className="logo-img" src={HpLogo} alt="hp"></img>
            </div>
            <div className="logo__box">
              <img className="logo-img" src={McdonaldLogo} alt="mcdonald"></img>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Social;
